import React from 'react';
import { Plug } from 'lucide-react';
import { Reveal } from './ui/Reveal';

const rowA = ['n8n', 'Make', 'Zapier', 'OpenAI', 'Anthropic', 'HubSpot', 'Salesforce', 'Shopify', 'Airtable', 'Notion'];
const rowB = ['WhatsApp', 'Twilio', 'Slack', 'Google Sheets', 'Supabase', 'Stripe', 'Pipedrive', 'Gmail', 'Telegram', 'PostgreSQL'];

const Pill: React.FC<{ label: string }> = ({ label }) => (
    <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-xl bg-white/[0.03] border border-white/[0.06] px-5 py-3 text-text-main font-medium hover:border-brand-cyan/40 hover:text-white transition-colors">
        <span className="w-1.5 h-1.5 rounded-full bg-brand-cyan/70" />
        {label}
    </span>
);

const Marquee: React.FC<{ items: string[]; reverse?: boolean }> = ({ items, reverse }) => (
    <div className="relative overflow-hidden marquee-hover-pause [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div
            className={`flex w-max gap-4 ${reverse ? 'animate-marquee-slow [animation-direction:reverse]' : 'animate-marquee'}`}
        >
            {[...items, ...items].map((item, i) => (
                <Pill key={`${item}-${i}`} label={item} />
            ))}
        </div>
    </div>
);

const Integrations: React.FC = () => {
    return (
        <section className="relative py-24 md:py-28 overflow-hidden">
            <div className="container-x">
                <Reveal className="text-center max-w-2xl mx-auto mb-12">
                    <span className="eyebrow mb-4 justify-center">
                        <Plug className="w-4 h-4" /> Integrations
                    </span>
                    <h2 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight">
                        Works with <span className="text-gradient">your entire stack</span>
                    </h2>
                    <p className="mt-4 text-text-muted text-lg">
                        We connect the tools you already use — and the 5,000+ others you might. If it has an API, we can automate it.
                    </p>
                </Reveal>
            </div>

            <div className="space-y-4">
                <Marquee items={rowA} />
                <Marquee items={rowB} reverse />
            </div>
        </section>
    );
};

export default Integrations;
